/// <reference path="../../typings/jquery/jquery.d.ts" />
/// <reference path="../../typings/jquery/jquery.extensions.d.ts" />
/// <reference path="interfaces.ts" />
var TotalJobsGroup;
(function (TotalJobsGroup) {
    var Header;
    (function (Header) {
        var ToggleTracking = (function () {
            function ToggleTracking($, tracking) {
                this.$ = $;
                this.tracking = tracking;
            }
            ToggleTracking.prototype.sendTrackingEventForElement = function ($element, isOpen) {
                if (isOpen) {
                    $element.data("tracking-event-description", $element.data("tracking-toggle-open-event-description"));
                }
                else {
                    $element.data("tracking-event-description", $element.data("tracking-toggle-close-event-description"));
                }
                this.tracking.sendTrackingInfo($element);
            };
            ToggleTracking.prototype.initialize = function ($context) {
                var $ = this.$;
                var self = this;
                var initTracking = function (index, element) {
                    var $element = $(element);
                    var targetElement = $element.data("target");
                    if ($.isNullOrUndefined(targetElement)) {
                        return;
                    }
                    var $targetElement = $context.find(targetElement);
                    if ($targetElement.length === 0) {
                        return;
                    }
                    $targetElement.on("shown.bs.collapse", function () {
                        self.sendTrackingEventForElement($element, true);
                    });
                    $targetElement.on("hidden.bs.collapse", function () {
                        self.sendTrackingEventForElement($element, false);
                    });
                };
                $(".toggle-tracking", $context).each(initTracking);
            };
            return ToggleTracking;
        }());
        Header.ToggleTracking = ToggleTracking;
    })(Header = TotalJobsGroup.Header || (TotalJobsGroup.Header = {}));
})(TotalJobsGroup || (TotalJobsGroup = {}));

//# sourceMappingURL=header-toggle-tracking.js.map
